module.exports = __webpack_public_path__ + "static/media/dev.e565e0b8.svg";